module.exports = __webpack_public_path__ + "img/blue.fa05d1ed.jpg";